export var messages = {
    currentStop: 'Current stop',
    departure: 'Departure',
    minute: 'minute',
    minutes: 'minutes',
    nextStop: 'Next stop',
    now: 'Now',
    predictedArrival: 'Predicted arrival',
    terminus: 'Terminus',
};
// TODO hungarian translation
// const huMessages: typeof messages = {
//     currentStop: 'Aktuális megálló',
//     departure: 'Indulás',
//     minute: 'perc',
//     minutes: 'perc',
//     nextStop: 'Következő megálló',
//     now: 'Most',
//     predictedArrival: 'Várható érkezés',
//     terminus: 'Végállomás',
// }



//////////////////
// WEBPACK FOOTER
// ./src/pages/MonitorDisplay/messages.ts
// module id = 1847
// module chunks = 0